
import { useStore } from "vuex";
import { defineComponent, ref } from "@vue/runtime-core";

import router from "@/router";
import Extra from "@/components/Extra.vue";
import Button from "../components/Button.vue";
import { authService } from "../services/auth";
import { ToastService } from "../services/toast";
import { toastError } from "../utils/toastError";

export default defineComponent({
  name: "Signup",
  props: {
    isLogin: Boolean,
  },
  components: {
    Button,
    Extra
  },
  setup(props) {
    const name = ref<string>("");
    const email = ref<string>("");
    const password = ref<string>("");

    const loading = ref<boolean>(false);
    const store = useStore();
    const toast = new ToastService();

    function onSubmit(e: Event) {
      e.preventDefault();
      loading.value = true;
      if (props.isLogin) {
        authService
          .login({
            email: email.value,
            password: password.value,
          })
          .then((response) => {
            toast.success(response.message);

            store.commit("auth/addUserToState", response.data.user);
            store.commit("auth/addTokenToState", response.data.accessToken);
            store.commit(
              "auth/addRefreshTokenToState",
              response.data.refreshToken
            );

            setTimeout(() => router.push("/dashboard"), 1000);
          })
          .catch((err) => {
            toastError(err);
          })
          .finally(() => (loading.value = false));
      } else {
        authService
          .signup({
            name: name.value,
            email: email.value,
            password: password.value,
          })
          .then((response) => {
            toast.success(response.message);
            setTimeout(() => router.push("/"), 1000);
          })
          .catch((err) => {
            toastError(err);
          })
          .finally(() => (loading.value = false));
      }
    }

    return { toast, loading, name, email, password, onSubmit };
  },
  inheritAttrs: false, // disable 'non-props' warning
});
